import { List, Pagination } from '@nackle/paper';
import React, { useRef, useState } from 'react';
import SessionItemView from './SessionItemView';

const defaultOptions = {
    showTopPaginator: true,
};

const SessionView = ( { data, options: _options, loading, registrationInfo, updateRegistrationCb, isLocked } ) => {

    const listRef = useRef();

    const options = { 
        ...defaultOptions,
        ..._options 
    };

    // currently assuming data exists wholly on init
    const [ paginationSpecs, setPaginationSpecs ] = useState( {
        pageSize: options?.pagination?.pageSize ?? 10,
        hideOnSinglePage: options.pagination?.hideOnSinglePage ?? true, 
        current: options.pagination?.overrideCurrent ?? 1,
        onChange: defaultOnPageChange,
        total: options.pagination?.overrideTotal ?? data?.length,
        showSizeChanger: false
    } );

    function defaultOnPageChange( page ) {
        // this function assumes the entire list has been fetched, as it typically is with compact items

        setPaginationSpecs( { ...paginationSpecs, current: page } );
    }

    const loadingItems = [ ...Array( options.loadingCount ?? options.pagination?.defaultPageSize ?? 10 ) ]
        .map( ( _, i ) => ( { key: i } ) );
    
    return (
        <div ref={ listRef } className="sessions-view">
            { options?.showTopPaginator && <Pagination className='top-paginator' { ...paginationSpecs } /> }
            <List
                itemLayout="horizontal"
                dataSource={ data?.length > 0 || !loading ? data : loadingItems } 
                pagination={ paginationSpecs }
                renderItem={ item => <SessionItemView isLocked={ isLocked } registrationInfo={ registrationInfo } updateRegistrationCb={ updateRegistrationCb } item={ item } options={ options } loading={ loading } />
                }
            /> 
        </div>
    );
};

export default SessionView;
